export const localizeNumber = (num: number) => {
  return num.toLocaleString('ko-KR');
};

/**
 * - [reference](https://github.com/banhala/ably-webview-react/blob/main/packages/webview/modules/eventLogger/func.ts#L8C1-L29C3)
 */
export const getNumberRange = ({
  rangeUnit,
  target,
}: {
  rangeUnit: number;
  target: number;
}) => {
  if (target === 0) return '0';

  const quotient = Math.floor(target / rangeUnit);
  const remainder = target % rangeUnit;

  if (remainder === 0) {
    return `${localizeNumber(
      (quotient - 1) * rangeUnit + 1,
    )}~${localizeNumber(quotient * rangeUnit)}`;
  }

  return `${localizeNumber(quotient * rangeUnit + 1)}~${localizeNumber(
    (quotient + 1) * rangeUnit,
  )}`;
};

export const formatNumber = (value: number) => {
  if (value >= 100000000) {
    return {
      value: parseFloat((value / 100000000).toFixed(1)),
      label: '억',
    };
  }
  if (value >= 10000) {
    return {
      value: parseFloat((value / 10000).toFixed(1)),
      label: '만',
    };
  }
  if (value >= 1000) {
    return {
      value: parseFloat((value / 1000).toFixed(1)),
      label: '천',
    };
  }
  return { value: value, label: '' };
};
